import styled from 'styled-components';

export const StyledInputLabel = styled.span`
  margin-top: 20px;
  height: 18px;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.01px;
  line-height: 18px;
  margin-bottom: 10px;
`;

export const StyledInput = styled.input`
  box-sizing: border-box;
  // height: 50px;
  /* width: 334px; */
  width: ${(props) => props.width || '100%'};
  border-radius: 4px;
  padding-left: 10px;

  &::placeholder {
    height: 19px;
    font-size: 16px;
    letter-spacing: 0.02px;
    line-height: 19px;
  }
`;

export const StyledError = styled.div`
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 5px;
  width: 100%;
  /* TODO: THEME */
  background-color: rgba(230, 34, 123, 0.1);
  color: #e6227b;
  text-align: center;
  & a {
    color: #e6227b;
  }
`;
